export default __webpack_public_path__ + "static/media/Bell.c0cafce8.svg";